import { findBlocks } from './block-boot';

const initialized = new WeakMap();

export function initTabsBlock(blockSelector, onClick = false, root = document) {
  const prefix = blockSelector.slice(1);

  findBlocks(root, blockSelector).forEach((block) => {
    if (initialized.has(block)) return;

    const navItems = block.querySelectorAll(`.${prefix}__nav-item`);
    const panels = block.querySelectorAll(`.${prefix}__panel`);
    const trigger = block.querySelector(`.${prefix}__nav-trigger`);
    const triggerLabel = block.querySelector(`.${prefix}__nav-trigger-label`);
    const navList = block.querySelector(`.${prefix}__nav`);

    function activate(index) {
      navItems.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        const btn = item.querySelector(`.${prefix}__nav-btn`);
        if (btn) {
          btn.setAttribute('aria-selected', String(i === index));
          btn.setAttribute('tabindex', i === index ? '0' : '-1');
        }
      });
      panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
        panel.setAttribute('aria-hidden', String(i !== index));
      });

      if (triggerLabel) {
        const btn = navItems[index].querySelector(`.${prefix}__nav-btn`);
        triggerLabel.textContent = btn.textContent.trim();
      }
    }

    function closeDropdown() {
      if (!trigger) return;
      trigger.setAttribute('aria-expanded', 'false');
      navList.classList.remove('is-open');
    }

    navItems.forEach((item, index) => {
      const btn = item.querySelector(`.${prefix}__nav-btn`);

      btn.addEventListener('click', () => {
        activate(index);
        closeDropdown();
      });

			  btn.addEventListener('keydown', (e) => {
				let newIndex;
				if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
						newIndex = (index + 1) % navItems.length;
					} else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
						newIndex = (index - 1	+ navItems.length) % navItems.length;
					} else if (e.key === 'Home') {
						newIndex = 0;
					} else if (e.key === 'End') {
						newIndex = navItems.length - 1;
					} else {
						return;
					}
					e.preventDefault();
					activate(newIndex);
					navItems[newIndex].querySelector(`.${prefix}__nav-btn`)?.focus();
				});
      
      if (!onClick) {
         item.addEventListener('mouseenter', () => {
          if (block.ownerDocument.defaultView.innerWidth > 768) activate(index);
        });
      }
    });

    if (trigger) {
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        navList.classList.toggle('is-open', !isOpen);
      });

      block.ownerDocument.addEventListener('click', (e) => {
        if (!block.contains(e.target)) closeDropdown();
      });
    }

    initialized.set(block, true);
  });
}
